import clsx from 'clsx'
import parse from 'html-react-parser'
import React from 'react'

import s from './styles.module.scss'

import { mainPictureByServiceProviderType } from './mainPictureByServiceProviderType'
import TagClientPricingItem from './tag-client-pricing-item/TagClientPricingItem'
import type { IServiceProvider } from '../house-services.type'
import { BackgroundImage } from '../../../../atoms'

interface IHouseServiceProps {
  service: IServiceProvider
  infosDisabled?: boolean
  className?: string
  selectPrestation?: {
    quantities: {
      [x: string]: { quantity?: number; priceId?: string; discountRate: number }
    }
    onSelectPrestation: ({
      clientPricingItemId,
      quantity,
      priceId,
    }: {
      clientPricingItemId: string
      quantity?: number
      priceId?: string
    }) => void
    disabled?: boolean
  }
  isApp?: boolean
}

const HouseService = ({
  service,
  infosDisabled = false,
  className,
  selectPrestation: _selectPrestation,
  isApp = false,
}: IHouseServiceProps) => {
  return (
    <div className={clsx(s.houseService, className)}>
      <div className={s.contentService}>
        <div className={s.imageService}>
          {service.mainPicture ? (
            <BackgroundImage
              src={service.mainPicture?.uri}
              style={{ borderRadius: '5px' }}
              type='cover'
              alt=''
            />
          ) : (
            <div className={s.emptyState}>
              {mainPictureByServiceProviderType(service.category ?? undefined)}
            </div>
          )}
        </div>
        <div className={s.containerInformations}>
          {!infosDisabled && (
            <>
              <h4 className={s.name}>{service.title}</h4>
              {service.readableId && (
                <div className={s.fontSize14}>{service.readableId}</div>
              )}
            </>
          )}
        </div>
      </div>
      {service.description && (
        <div className={s.description}>{parse(service.description)}</div>
      )}

      {service.clientPricingItems && service.clientPricingItems?.length > 0 && (
        <div className={s.pricesContainer}>
          {service.clientPricingItems?.map((clientPricingItem) => {
            return (
              <TagClientPricingItem
                key={clientPricingItem._id}
                clientPricingItem={clientPricingItem}
                className={s.serviceProvision}
                hasRoundedPrice={isApp}
                isApp={isApp}
                showTotalPrice={false}
              />
            )
          })}
        </div>
      )}
    </div>
  )
}

export default HouseService
